export default __webpack_public_path__ + "static/media/close-circle-line.c7b3ff24.svg";